const NoRender = () => null

export default NoRender
